<template>
  <div class="logo_color_box_2">
    <div class="title_box">
      <img v-if="LogoPath" :src="LogoPath" alt="logo" style="height: 0.7rem;width: 0.7rem;margin-right: 0.3rem;">
      <p>{{ title }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogoTitleGradient', // Vue2推荐显式声明组件名
  // 替换Vue3的defineProps，使用Vue2的props选项
  props: {
    title: {
      type: String,
      default: ''
    },
    LogoPath: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
/* 1. 移除lang="scss"；2. 展开SCSS嵌套为普通CSS；3. 批量替换--el开头的CSS变量 */
.logo_color_box_2 {
  padding: 0 1rem;
  width: 70%;
  background-color: var(--color-primary-dark-2); /* 原--el-color-primary-dark-2 → --color-primary-dark-2 */
  background: linear-gradient(
    to right,
    var(--color-primary-light-5), /* 原--el-color-primary-light-5 → --color-primary-light-5 */
    var(--color-primary-dark-2) 40%,  /* 原--el-color-primary-dark-2 → --color-primary-dark-2 */
    var(--color-primary-dark-2) 60%,  /* 原--el-color-primary-dark-2 → --color-primary-dark-2 */
    var(--color-primary-light-5)      /* 原--el-color-primary-light-5 → --color-primary-light-5 */
  );
}

.logo_color_box_2 .title_box {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>